import "../components/cacheForm.js";

$(document).ready(function() {
  const toggleLoading = function() {
    $('body').toggleClass('is-loading');
  }


  // HS - Mapping
  // @ToDo move to server and/or centralize somewhere?
  // also currently the keys are in no way standardized, however recruiting wanted to use them this way
  const languageMap = {
    DE: 'German',
    EN: 'English',
    FR: 'French',
    IT: 'Italian',
    SP: 'Spanish',
    DU: 'Dutch',
    GR: 'Greek',
    RU: 'Russian',
    PR: 'Portuguese',
    TR: 'Turkish'
  }

  const mapLanguage = function(language) {
    var defaultLang = language.split('/')[0].trim();
    return languageMap[defaultLang.toUpperCase()] ? languageMap[defaultLang.toUpperCase()] : null;
  }

  // if job position is provided via query param, its preselected here
  const initializePreselectedValues = function($form) {
    if (document.preselected.position) {
      $form.find('select[name="job_position"] option')
        .filter(function() {
          return $(this).text() == document.preselected.position;
        })
        .prop('selected', true)
        .change();
    }

    if (document.preselected.language) {
      const hsLanguage = mapLanguage(document.preselected.language);

      if (hsLanguage && hsLanguage !== document.preselected.language) {
        $('input[name="language"]').val(hsLanguage).change();
      }
    }
  }

  const initializeFileUpload = function() {
    $('.hs-fieldtype-file .input').attr('data-content', document.selectFileLabel);
    $('input[type="file"]').change(function(e){
      var files = e.currentTarget.files;
      var name = files && files.length ? files[0].name : null;

      if (name) {
        $(e.currentTarget).parent().attr('data-content',name);
      }
    });
  }

  const renderDone = function(index) {
    $('*[data-indicator-index]').each(function() {
      const el = $(this);
      const elIndex = parseInt(el.data('indicator-index'));
      if (!isNaN(elIndex) && elIndex < index) {
        el.addClass('d-none');
        $('*[data-indicator-done=' + elIndex + ']').removeClass('d-none');
      } else {
        el.removeClass('d-none');
        $('*[data-indicator-done=' + elIndex + ']').addClass('d-none');
      }
    });
  }

  const renderProgress = function(index) {
    $('*[data-page-index]').removeClass('active');
    $('*[data-page-index=' + index + ']').addClass('active');
    renderDone(index);
  }

  const renderPrevButton = function($form, prevIndex) {
    const elActions = $form.find('.hs-submit .actions');
    const markup = '<a href="#" class="btn btn-sm btn-secondary mt-16 mt-md-0" data-previous="' + prevIndex + '">' + document.prevButtonLabel + '</a>';
    elActions.append(markup)
    elActions.addClass('flex-column flex-md-row-reverse justify-content-md-between')
  }

  // injects email in hidden fields on subsequent forms
  const injectEmail = function() {
    if (document.formData.email && document.formData.email.length > 0) {
      // wait a bit to make sure to overwrite all other auto fill settings
      setTimeout(function() {
        $('input[name="email"]').val(document.formData.email).change();
      }, 500);

    }
  }

  const cacheForm = function($form, index) {
    const conf = {};
    if (index === 0) {
      conf.elements = 'input[type="email"], input[type="text"], input[type="tel"], input[type="radio"], input[type="checkbox"], select, textarea';
    }

    $form.FormCache(conf);
  }

  const cleanUp = function() {
    if(typeof(Storage)!=="undefined"){
      localStorage.clear();
    }
  }

  const createHSForm = function(index) {
    // create form
    hbspt.forms.create({
      portalId: document.portalId,
      formId: document.formIds[index],
      target: document.targetId,

      onFormReady: function($form) {
        if (!document.formData) document.formData = {};

        renderProgress(index);

        initializeFileUpload();

        // populate email field (hidden in all but first form)
        injectEmail($form);

        // limit amount of chars in message field
        $('input[name="message"]').attr('maxlength','255').change();
        $('textarea[name="message"]').attr('maxlength','255').change();

        fillFormWithGA();

        // inject previous button
        if (index > 0) {
          var prevIndex = index - 1;

          renderPrevButton($form, prevIndex);

          // register event handler for prev button
          $form.on('click', '[data-previous]', function(evt){
            toggleLoading();
            createHSForm($(evt.currentTarget).data('previous'));
          });
        } else {
          initializePreselectedValues($form)
        }

        cacheForm($form, index);
        toggleLoading();

      },
      onFormSubmit: function($form) {
        toggleLoading();

        window.dataLayer = window.dataLayer || [];

        var queryString = window.location.search;
        if (typeof queryString !== "undefined" && queryString !== "") {
          var urlParams = new URLSearchParams(queryString);
          if (urlParams && urlParams.has('tduid')) {
            var tduid = urlParams.get('tduid');
            tduid = tduid.replace(/[^a-zA-Z0-9]/gi, '');
            window.dataLayer.push({
              'tduid USER': tduid
            });
          }
        }

        if (typeof gtag !== 'undefined') {
          gtag('event', 'conversion', {'send_to': 'AW-874316721/jLmiCLuOqGoQsYf0oAM'});
          gtag('event', 'form.submit', {});
        }

        // store email address to populate fields in subsequent forms
        // this makes sure tracking works in any case
        if (index === 0) {
          var email = $form.find('input[name="email"]').val();
          document.formData.email = email;
        }

        var subjectSelected = $('select[name="trial_session_subject"]').val();
        window.dataLayer.push({
          event: "form_submit_success",
          form_type: "trial",
          page_url: window.location.href,
          subject: subjectSelected
        });
      },
      onFormSubmitted: function($form) {
        if (index < document.formIds.length && document.formIds.length !== 1) {
          index ++;
          createHSForm(index);
        } else {
          // clean up
          cleanUp();

          // redirect if simple form
          if (document.thankYouUrl) {
            window.location.replace(document.thankYouUrl);
          }
        }
      }
    });
  }

  // FLOW
  var index = 0;
  toggleLoading();
  $(document).ready(function(){
    createHSForm(index);
  });
});
